import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_4 = { class: "ant-row" }
const _hoisted_5 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-24"
}
const _hoisted_6 = {
  key: 1,
  class: "ant-col ant-col-xs-24 ant-col-xl-24"
}
const _hoisted_7 = {
  key: 2,
  class: "ant-col ant-col-xs-24 ant-col-xl-24"
}
const _hoisted_8 = { class: "ant-row" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Cancelar", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Salvar", -1)
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_tipo_filtro_relatorio_p_c_p = _resolveComponent("selecionar-tipo-filtro-relatorio-p-c-p")!
  const _component_selecionar_tipo_producao = _resolveComponent("selecionar-tipo-producao")!
  const _component_selecionar_engenharia_producao = _resolveComponent("selecionar-engenharia-producao")!
  const _component_selecionar_produto = _resolveComponent("selecionar-produto")!
  const _component_selecionar_campos_relatorio_p_c_p = _resolveComponent("selecionar-campos-relatorio-p-c-p")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    title: _ctx.modoEdicao ? 'Editar Layout' : 'Novo Layout',
    onCancel: _ctx.fecharModal,
    width: 1000,
    destroyOnClose: true
  }, {
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "ant-btn",
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.fecharModal && _ctx.fecharModal(...args)))
      }, _hoisted_11),
      _createElementVNode("button", {
        type: "button",
        class: "ant-btn ant-btn-primary",
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.salvarLayout && _ctx.salvarLayout(...args)))
      }, _hoisted_13)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_a_form_item, {
                label: "Descrição do Relatório",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "ant-input",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dadosCadastro.descricao) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.dadosCadastro.descricao]
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_a_form_item, {
                label: "Filtrar Por",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_selecionar_tipo_filtro_relatorio_p_c_p, {
                    codigosSelecionados: _ctx.dadosCadastro.tiposFiltro,
                    "onUpdate:codigosSelecionados": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dadosCadastro.tiposFiltro) = $event))
                  }, null, 8, ["codigosSelecionados"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.dadosCadastro.tiposFiltro?.includes(1))
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_a_form_item, {
                    label: "Tipo de Produção",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_tipo_producao, {
                        varios: true,
                        codigosSelecionados: _ctx.tipoProducao,
                        "onUpdate:codigosSelecionados": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tipoProducao) = $event)),
                        disabled: false,
                        empresas: [_ctx.codigoEmpresa]
                      }, null, 8, ["codigosSelecionados", "empresas"])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.dadosCadastro.tiposFiltro?.includes(2))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_a_form_item, {
                    label: "Engenharia de Produto",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_engenharia_producao, {
                        varios: true,
                        codigosSelecionados: _ctx.engenhariaProdutos,
                        "onUpdate:codigosSelecionados": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.engenhariaProdutos) = $event)),
                        disabled: false,
                        empresas: [_ctx.codigoEmpresa],
                        tipoProducao: 0
                      }, null, 8, ["codigosSelecionados", "empresas"])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.dadosCadastro.tiposFiltro?.includes(3))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_a_form_item, {
                    label: "Matéria-Prima",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_produto, {
                        varios: true,
                        codigosSelecionados: _ctx.materiasPrimas,
                        "onUpdate:codigosSelecionados": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.materiasPrimas) = $event)),
                        disabled: false,
                        empresas: [_ctx.codigoEmpresa]
                      }, null, 8, ["codigosSelecionados", "empresas"])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_selecionar_campos_relatorio_p_c_p, {
                campos: _ctx.dadosRelatorioCampos,
                "onUpdate:campos": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dadosRelatorioCampos) = $event))
              }, null, 8, ["campos"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible", "title", "onCancel"]))
}